export default __webpack_public_path__ + "static/media/FormBCertificate.bf60c5e6.png";